import { Button, Typography } from '@mui/material';

import { useAppDispatch } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { signOut } from '@/redux/auth/actions';

import { FinishedLogo, StyledFinishedScreen } from './CreateNewAccount.styled';

export default function JointAdultAgeValidationFailedScreen() {
  const { t } = useTranslate();
  const dispatch = useAppDispatch();
  const onBackToSignIn = () => dispatch(signOut());

  return (
    <StyledFinishedScreen>
      <FinishedLogo />

      <Typography variant="body2" textAlign="center" mb={2}>
        {t('createNewAccount.jointAdultAgeValidationFailed.body')}
      </Typography>
      <Typography variant="body2" textAlign="center" mb={4}>
        {t('createNewAccount.jointAdultAgeValidationFailed.body2')}
      </Typography>
      <Button fullWidth onClick={onBackToSignIn} variant="text">
        {t('createNewAccount.jointAdultAgeValidationFailed.button.backToLogin')}
      </Button>
    </StyledFinishedScreen>
  );
}
